import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";

export const VideoModal = ({ open, onOpenChange, video }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      className="max-w-4xl border-border bg-[#0D0B0A] p-0 sm:rounded-none"
      data-testid="video-modal"
    >
      <DialogTitle className="sr-only">{video?.title || "Video"}</DialogTitle>
      {video && (
        <div className="aspect-video w-full bg-black">
          <iframe
            className="h-full w-full"
            src={video.vimeoId
              ? `https://player.vimeo.com/video/${video.vimeoId}?autoplay=1&title=0&byline=0&portrait=0`
              : `https://www.youtube.com/embed/${video.youtubeId}?autoplay=1&rel=0${video.start ? `&start=${video.start}` : ""}`}
            title={video.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            data-testid="video-iframe"
          />
        </div>
      )}
      {video && (
        <div className="flex items-center justify-between px-6 py-4">
          <span className="font-display text-2xl text-sand-100">{video.title}</span>
          <span className="overline text-sand-400">{video.category} — {video.year}</span>
        </div>
      )}
    </DialogContent>
  </Dialog>
);

export default VideoModal;
